import { render, staticRenderFns } from "./Line-Item-Projects.vue?vue&type=template&id=5d48ce3d"
import script from "./Line-Item-Projects.vue?vue&type=script&lang=js"
export * from "./Line-Item-Projects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports